import axios from "axios";

export const controlSponsorApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/control-sponsor`,
  headers: {
    "Content-Type": "application/json",
  },
});
